// extracted by mini-css-extract-plugin
export default {"sticky-header":"BaseAgGrid_sticky-header__-ixt0"};